const processProduct = (cards, products) => (product) => {
  if (!product) {
    return;
  }

  product.variants.forEach((v) => {
    if (v.available) {
      const av = cards.find(p => btoa(`gid://shopify/ProductVariant/${p.variant_id}`) === v.id);

      if (av !== undefined) {
        let image;
        if (product.images[0] === undefined) {
          image = '';
        } else {
          image = product.images[0].src;
        }

        const existing = products.find(p => p.variant.id === v.id);

        if (!existing) {
          products.push({
            quantity: 0,
            available_quantity: av.quantity,
            variant: v,
            title: product.title,
            image,
          });
        }
      }
    }
  });
};

export default processProduct;



// WEBPACK FOOTER //
// ./src/process-product.js